// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"aP-z","inlineTitle":"bP-z","sponsoredAdsWrapper":"cP-z","marketplaceRecosWrapper":"dP-z"};